"use client";

import React, { useState, useEffect } from "react";
import { ArrowLeft, Clock, Award, Flame } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function UltimateSmokingExperience() {
  const [isMounted, setIsMounted] = useState(false);
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  useEffect(() => {
    setIsMounted(true);
  }, []);

  // Extract YouTube video ID from URL
  const getYouTubeEmbedUrl = (url: string) => {
    const videoId = url.split("v=")[1] || url.split("/").pop();
    return `https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1&loop=1&playlist=${videoId}&controls=0&showinfo=0&rel=0&modestbranding=1&playsinline=1`;
  };
  return <section id="חוויית-העישון-האולטימטיבית" className="dark bg-background text-foreground relative w-full h-screen min-h-[700px] overflow-hidden flex items-center justify-center">
      {/* Background Video */}
      <div className="absolute inset-0 z-0 select-none pointer-events-none overflow-hidden">
        <div className="absolute inset-0 bg-black/20 z-10" /> {/* Dark overlay */}
        {isMounted && <div className="relative w-full h-full scale-125">
            <iframe src={getYouTubeEmbedUrl("https://www.youtube.com/watch?v=ScMzIvxBSi4")} title="Background Video" allow="autoplay; encrypted-media" className="absolute top-1/2 left-1/2 w-[177.77777778vh] h-[56.25vw] min-h-full min-w-full -translate-x-1/2 -translate-y-1/2" style={{
          border: 'none'
        }} />
          </div>}
      </div>

      {/* Gradient Overlays */}
      <div className="absolute inset-0 z-10 bg-gradient-to-t from-background via-background/60 to-black/40" />
      <div className="absolute inset-0 z-10 bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1557505/img/noise_texture.png')] opacity-5 mix-blend-overlay" />

      {/* Content */}
      <div ref={ref} className={`relative z-20 container mx-auto px-4 flex flex-col items-center text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
        {/* Badge */}
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-primary/30 bg-primary/10 backdrop-blur-md mb-8">
          <Flame className="w-4 h-4 text-primary animate-pulse" />
          <span className="text-sm font-medium text-primary-foreground tracking-wide uppercase">
            SMOKE & GO
          </span>
        </div>

        {/* Main Heading */}
        <h1 className="text-5xl md:text-7xl lg:text-8xl font-black tracking-tighter text-transparent bg-clip-text bg-gradient-to-b from-primary to-red-700 mb-6 drop-shadow-2xl">חווית שף מעושנת<br />אצלכם בשולחן</h1>

        {/* Subheading */}
        <p className="text-xl md:text-2xl text-gray-200 max-w-2xl mx-auto mb-10 font-light leading-relaxed">
          שילוב מדויק בין בשר איכותי, עישון איטי וטעמים עמוקים – 
          <span className="font-semibold text-white"> מוכן לקחת הביתה ברגע.</span>
        </p>

        {/* Feature Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12 w-full max-w-lg">
          <div className="flex items-center justify-center gap-3 p-4 rounded-xl bg-card/30 backdrop-blur-sm border border-white/10">
            <Award className="w-6 h-6 text-primary" />
            <span className="text-lg font-medium text-white">איכות פרימיום</span>
          </div>
          <div className="flex items-center justify-center gap-3 p-4 rounded-xl bg-card/30 backdrop-blur-sm border border-white/10">
            <Clock className="w-6 h-6 text-primary" />
            <span className="text-lg font-medium text-white">שירות מהיר</span>
          </div>
        </div>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto">
          <Button asChild size="lg" className="h-14 px-8 text-lg bg-primary hover:bg-primary/90 text-white shadow-[0_0_20px_rgba(220,38,38,0.5)] border-none">
            <Link to="/SmokedMenuPage">התפריט שלנו<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-arrow-left w-5 h-5 mr-2" aria-hidden="true" data-ast-id="f:/src/pages/Home/sections/UltimateSmokingExperience.tsx|sig:hczdka" data-ast-start="4424" data-ast-end="4462"><path d="m12 19-7-7 7-7"></path><path d="M19 12H5"></path></svg></Link>
          </Button>
          
          <Button asChild variant="outline" size="lg" className="h-14 px-8 text-lg border-white/20 bg-black/20 text-white hover:bg-white/10 hover:text-white backdrop-blur-sm">
            <Link to="/OurStoryPage">
              הסיפור שלנו
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}